/**
 * Bulk Bundle Variation Handler
 *
 * Handles enabling/disabling Buy Now buttons in bulk/bundle discount tables
 * for variable products based on variation selection and applicability.
 */
(function ($) {
	'use strict';

	if (typeof $ === 'undefined') {
		return;
	}

	const DiscoBulkBundleVariation = {
		/**
		 * Initialize the variation handler.
		 */
		init: function () {
			this.tables = $('.disco-bulk-bundle-table-wrapper[data-disco-is-variable="1"]');

			if (!this.tables.length) {
				return;
			}

			this.bindEvents();
		},

		/**
		 * Bind WooCommerce variation events.
		 */
		bindEvents: function () {
			const self = this;

			// When a variation is found/selected.
			$('.variations_form').on('found_variation', function (event, variation) {
				self.onVariationFound(variation);
			});

			// When variation selection is reset.
			$('.variations_form').on('reset_data', function () {
				self.onVariationReset();
			});

			// When variation selection is cleared/hidden.
			$('.variations_form').on('hide_variation', function () {
				self.onVariationReset();
			});
		},

		/**
		 * Handle when a variation is selected.
		 *
		 * @param {Object} variation The variation data from WooCommerce.
		 */
		onVariationFound: function (variation) {
			const self = this;
			const variationId = variation.variation_id;

			if (!variationId) {
				this.onVariationReset();
				return;
			}

			this.tables.each(function () {
				const $table = $(this);
				const campaignId = $table.data('disco-campaign-id');
				const productId = $table.data('disco-product-id');

				self.checkVariationApplicability($table, campaignId, productId, variationId);
			});
		},

		/**
		 * Handle when variation selection is reset.
		 */
		onVariationReset: function () {
			this.tables.each(function () {
				const $table = $(this);
				const $buttons = $table.find('.disco-bulk-bundle-btn');

				$buttons.each(function () {
					const $btn = $(this);
					$btn.prop('disabled', true);
					$btn.addClass('disabled');
					$btn.css({
						cursor: 'not-allowed',
						opacity: '0.5',
						'pointer-events': 'none',
					});
					$btn.removeAttr('href');
					$btn.removeData('variation-id');
				});
			});
		},

		/**
		 * Check if the selected variation is applicable for the campaign.
		 *
		 * @param {jQuery}  $table      The table wrapper element.
		 * @param {number}  campaignId  The campaign ID.
		 * @param {number}  productId   The parent product ID.
		 * @param {number}  variationId The selected variation ID.
		 */
		checkVariationApplicability: function ($table, campaignId, productId, variationId) {
			const self = this;
			const $buttons = $table.find('.disco-bulk-bundle-btn');

			// Show loading state.
			$buttons.css('opacity', '0.5');

			$.ajax({
				url: discoBulkBundleVariation.ajaxUrl,
				type: 'POST',
				data: {
					action: 'disco_check_variation_applicability',
					nonce: discoBulkBundleVariation.nonce,
					campaign_id: campaignId,
					product_id: productId,
					variation_id: variationId,
				},
				success: function (response) {
					if (response.success && response.data.applicable) {
						self.enableButtons($buttons, variationId);
					} else {
						self.disableButtons($buttons);
					}
				},
				error: function () {
					self.disableButtons($buttons);
				},
			});
		},

		/**
		 * Enable the Buy Now buttons.
		 *
		 * @param {jQuery} $buttons    The button elements.
		 * @param {number} variationId The variation ID.
		 */
		enableButtons: function ($buttons, variationId) {
			$buttons.each(function () {
				const $btn = $(this);
				const quantity = $btn.data('disco-quantity') || 1;

				$btn.prop('disabled', false);
				$btn.removeClass('disabled');
				$btn.css({
					cursor: 'pointer',
					opacity: '1',
					'pointer-events': 'auto',
				});
				$btn.data('variation-id', variationId);

				// Build add to cart URL for variation.
				const baseUrl = window.location.href.split('?')[0];
				const addToCartUrl =
					baseUrl +
					'?add-to-cart=' +
					variationId +
					'&quantity=' +
					quantity;

				// Convert button to link or update click handler.
				$btn.off('click.discoBulkBundle').on('click.discoBulkBundle', function (e) {
					e.preventDefault();
					window.location.href = addToCartUrl;
				});
			});
		},

		/**
		 * Disable the Buy Now buttons.
		 *
		 * @param {jQuery} $buttons The button elements.
		 */
		disableButtons: function ($buttons) {
			$buttons.each(function () {
				const $btn = $(this);
				$btn.prop('disabled', true);
				$btn.addClass('disabled');
				$btn.css({
					cursor: 'not-allowed',
					opacity: '0.5',
					'pointer-events': 'none',
				});
				$btn.off('click.discoBulkBundle');
			});
		},
	};

	// Initialize when DOM is ready.
	$(document).ready(function () {
		DiscoBulkBundleVariation.init();
	});
})(jQuery);
